import styled from 'styled-components'

import { BaseCell } from '../../DataGrid.styles'

export const RowsGroupHeaderRow = styled(BaseCell)<{ $headerHeightVar?: string }>`
  grid-column: 1 / -1;
  background-color: ${({ theme }) => theme.rowsGroupHeaderBackground};
  display: flex;
  ${({ $headerHeightVar }) =>
    $headerHeightVar &&
    `
    position: sticky;
    top: var(${$headerHeightVar});
    z-index: 2;
  `}
`

export const RowsGroupHeaderCell = styled(BaseCell)<{
  $headerHeightVar?: string
  $isPinnedColumn: boolean
}>`
  background-color: ${({ theme }) => theme.rowsGroupHeaderBackground};
  display: flex;
  ${({ $headerHeightVar }) => $headerHeightVar && `top: var(${$headerHeightVar});`}
  z-index: ${({ $isPinnedColumn }) => ($isPinnedColumn ? 3 : 2)};
`

export const RowsGroupHeaderRowContent = styled.div`
  position: sticky;
  left: ${({ theme }) => `${theme.firstColumnPadding}px`};
`
